import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ 
  children,
  allowedRoles = [] // Array of roles allowed to access this route
}) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // You can replace this with a proper loading component
    return (
      <div className="min-h-screen bg-[#FAF9FF] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0C60F2]"></div>
      </div>
    );
  }

  if (!user) {
    // Redirect them to the login page, but save the current location they were
    // trying to go to when they were redirected.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if role-based access control is enabled for this route
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Redirect to a forbidden page or dashboard based on your requirements
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;